import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialProps {
  name: string;
  location: string;
  text: string;
}
const TestimonialCard = ({
  name,
  location,
  text
}: TestimonialProps) => <div className="bg-brand-card p-4 md:p-5 rounded-xl border border-white/10 flex flex-col h-full hover:border-brand-accent/30 transition-colors" data-id="element-282">
    <div className="flex items-center mb-3" data-id="element-283">
      <div className="w-10 h-10 bg-brand-accent text-white rounded-full flex items-center justify-center font-bold text-lg mr-3 shrink-0" data-id="element-284">
        {name.charAt(0)}
      </div>
      <div data-id="element-285">
        <div className="flex text-brand-accent mb-0.5" data-id="element-286">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-current" data-id="element-287" />)}
        </div>
        <p className="font-bold text-white text-sm leading-tight" data-id="element-288">{name}</p>
        <p className="text-[10px] md:text-xs text-gray-500" data-id="element-289">📍 {location}</p>
      </div>
    </div>
    <p className="text-gray-400 text-sm italic flex-grow leading-relaxed" data-id="element-290">
      "{text}"
    </p>
  </div>;
export function TestimonialsSection2() {
  const testimonials = [{
    name: 'Cecilia R.',
    location: 'Mendoza | Escuela Técnica N°1 — Electrotecnia',
    text: 'Por fin tengo guías de TP que cumplen con la AEA. Antes buscaba en libros viejos y adaptaba durante horas. Ahora entro al taller con la ficha lista y los alumnos trabajan desde el minuto uno.'
  }, {
    name: 'Roberto M.',
    location: 'Buenos Aires | Maestro de Taller — Instalaciones Eléctricas',
    text: 'El tomo de tableros y protecciones me cambió las clases. Los chicos entendieron la selectividad con la planilla de cálculo. Antes les explicaba en el pizarrón y no quedaba nada. Ahora calculan ellos.'
  }, {
    name: 'Sofía C.',
    location: 'Córdoba | Profesora de Electrotecnia — 4° y 5° año',
    text: 'Mis alumnos nunca entendían para qué servía la puesta a tierra. Con el Tomo 4 y el caso práctico del telurímetro, lo midieron ellos mismos y no se olvidaron más. Fue un antes y un después.'
  }, {
    name: 'Pablo A.',
    location: 'Neuquén | Docente de Taller — Técnica Industrial',
    text: 'Los proyectos integradores del upsell me salvaron el cierre de año. Tenía 25 alumnos, 3 grupos distintos y necesitaba proyectos diferentes para cada uno. Ya los tenía todos listos con sus rúbricas. No inventé nada.'
  }, {
    name: 'Martín G.',
    location: 'Santa Fe | Maestro de Enseñanza Práctica',
    text: 'El banco de problemas resueltos es oro puro. Ya no tengo que inventar ejercicios de caída de tensión la noche anterior. Imprimo, reparto y los chicos practican con casos de obras reales.'
  }];
  return <section className="py-10 md:py-16 px-4 bg-brand-dark" data-id="element-291">
      <div className="max-w-5xl mx-auto" data-id="element-292">
        <h2 className="text-2xl md:text-3xl font-black text-center mb-8 text-white" data-id="element-293">
          ❤️ LO QUE DICEN LOS DOCENTES QUE YA LO TIENEN
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-294">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-295" />)}
        </div>
      </div>
    </section>;
}